<template>
  <div class="main-view-padding has-header">
    <div class="header main" v-header-position-lock>
          <div class="align-left">
          </div>
          <div class="align-middle">
                <headerbuttonstack :state="headerButtons"/>
          </div>
          <div class="align-right">
          </div>
      </div>
    <div style="font-size: 32px; text-align: left; color: #e51550; border-bottom:1px solid #ccc; padding: 5px; font-weight:400; margin-bottom:25px;">
        {{ $t('global.ui.costCenters') }}
    </div>
    <div v-if="duplicateCostCenterNumbers.size > 0" style="
        margin: 20px auto;
        padding: 15px;
        max-width: 800px;
        border: 1px solid #ffb3b3;
        border-radius: 4px;
        background-color: #ffe6e6;
        color: #800000;
        text-align: center;
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    ">
        {{ $t('settings.centers.duplicateCostCenterWarning') }}
    </div>

    <div>
      <table class="styled-table">
        <tr>
          <th class="center">{{ $t('settings.centers.location') }}</th>
          <th>{{ $t('settings.groups.name') }}</th>
          <th>{{ $t('settings.centers.abbr') }}</th>
          <th>{{ $t('settings.groups.number') }}</th>
          <th>{{ $t('settings.centers.desc') }}</th>


          <th class="center">{{ $t('settings.centers.visible') }}</th>
          <th class="center">{{ $t('settings.ui.edit') }}</th>
          <th class="center">{{ $t('settings.notes.delete') }}</th>
        </tr>
        <tr v-for="x in costCenters" v-bind:key="x.id">
          <td class="center">
            <select v-if="!x.isDefault" v-model="x.storeId" @change="storeChanged(x)">
              <option :value="null">– {{ $t('settings.centers.noStore') }} –</option>
              <option v-for="store in storesData" :key="store.id" :value="store.id">
                {{ store.name }}
              </option>
            </select>
            <span v-else>
              <i v-if="x.isDefault" class="fas fa-star" style="color: gray; cursor:default;" :title="$t('settings.centers.systemDefault')"></i>
            </span>
          </td>
          <td>{{x.name}}</td>
          <td>{{x.shortName}}</td>
          <td>
            {{ x.costCenterNumber }}
            <i v-if="isDuplicate(x)" class="fas fa-exclamation-triangle" style="color: red; margin-left: 5px; cursor:default;" :title="$t('settings.centers.numberDuplicate')"></i>
          </td>
          <td>{{x.description}}</td>
          <td class="center">

      <button class="icon-button" @click="toggleVisibility(x)">
        <i v-if="x.isVisible" class="fas fa-check-circle" style="color: green;"></i>
        <i v-else class="fas fa-ban" style="color: red;"></i>
      </button>
          </td>
          <td class="center">
            <button class="icon-button" v-on:click="openEditCostCenter(x)">
              <i class="fas fa-edit"></i>
            </button>
          </td>
          <td class="center">
            <button class="icon-button" v-if="!x.isDefault" v-on:click="openDeleteCostCenter(x)">
              <i class="fas fa-trash"></i>
            </button>
          </td>
        </tr>
      </table>
    </div>
  </div>

</template>

<script>
import { mapState, mapGetters } from 'vuex';
import button from '../uicomponents/button.vue';
export default {
 components: { button },
  name: 'costCenters',
  data () {
    return {
      loading: true,
      saves: false,
      costCenters: [],
      storesData: [],
      duplicateNumberWarning: false,
    }
  },
  created: function () {
    if(this.$store.state.jwt != undefined && this.$store.state.companyId != undefined){
        this.refresh();
    }
  },
  mounted: function () {
    // this.loadStores(); // moved to refresh to ensure stores are loaded on company change
  },
  computed: {
        ...mapGetters(['companyId']),
          headerButtons() {
              let view = this;

              let state= {
                  buttons: []
              };
              state.buttons.push({
                  type: "block",
                  icon: "fa-refresh",
                  click: () => {
                     view.refresh(true);
                  },
                  tooltip: view.$t('settings.centers.reloadData')
              });
              state.buttons.push({
                  type: "block",
                  icon: "fa-plus",
                  click: ($event) => {
                     view.openNewCostCenter($event);
                  },
                  tooltip: view.$t('settings.centers.createNewCostCenter')
              });
              return state;
          },
          duplicateCostCenterNumbers() {
            const seen = new Map();
            const duplicates = new Set();

            for (const cc of this.costCenters) {
              if (!cc || typeof cc.costCenterNumber !== 'string') continue; // Fehler abfangen

              const trimmed = cc.costCenterNumber.trim();
              if (trimmed === '') continue;

              if (seen.has(trimmed)) {
                duplicates.add(trimmed);
              } else {
                seen.set(trimmed, cc.id);
              }
            }

            return duplicates;
          }
  },
  watch: {
    companyId: function(val, oldVal) {
      this.refresh();
    },
  },
  // methods that implement data logic.
  methods: {
    refresh: function(force = false){
      let view = this;
      view.loading = true;
      view.loadStores();
      view.$helpers.GetCostCenterArray(force).then((response) => {
        // console.log(response);
        view.costCenters = response;
      });
    },
    loadStores() {
      const view = this;
      view.$helpers.GetStoresSettings(true).then((response) => {
        view.storesData = response.data;
      });
    },
    getStoreName(storeId) {
      const match = this.storesData.find(s => s.id === storeId);
      return match ? match.name : '';
    },
    storeChanged(costCenter) {
      this.editCostCenter(costCenter);
    },
    isDuplicate(cc) {
      if (!cc || typeof cc.costCenterNumber !== 'string') return false;
      const trimmed = cc.costCenterNumber.trim();
      return this.duplicateCostCenterNumbers.has(trimmed);
    },


    toggleVisibility(costCenter) {
      const view = this;
      const url = view.$helpers.appendParam(
        "companyId",
        view.$store.state.companyId,
        `/api/costcenters/${costCenter.id}`,
        `/api/costcenters/${costCenter.id}`
      );

      const payload = {
        companyId: view.$store.state.companyId,
        costCenterNumber: costCenter.costCenterNumber,
        name: costCenter.name,
        shortName: costCenter.shortName,
        description: costCenter.description,
        isVisible: !costCenter.isVisible
      };

      view.axios({
        method: 'put',
        headers: {
          'AUTHORIZATION': "Bearer " + view.$store.state.jwt
        },
        url: url,
        data: payload
      }).then(response => {
        costCenter.isVisible = !costCenter.isVisible;
          view.$helpers.success(
              view.$t('settings.centers.visibilityChanged'),
              view.$t('settings.centers.costCenterUpdated')
          );
      }).catch(error => {
        console.error(error);
      });
    },


    openNewCostCenter(event){
        let view = this;
        let dataEntries = [

            {label: view.$t('settings.groups.name') + ': ', key: 'name', hidden: false, type: 'text', value: '', length: 128, styles: {'width': '350px'}},
            {label: view.$t('settings.centers.abbr') + ': ', key: 'shortName', hidden: false, type: 'text', value: '', length: 8, styles: {'width': '350px'}},
            {label: view.$t('settings.groups.number') + ': ', key: 'costCenterNumber', hidden: false, type: 'text', value: '', length: 128, styles: {'width': '350px'}},
            {label: view.$t('settings.centers.desc') + ': ', key: 'description', hidden: false, type: 'text', value: '', length: 128, styles: {'width': '350px'}},
            //{label: 'Latitude: ', key: 'latitude', hidden: false, type: 'text', value: '', length: 128, styles: {'width': '350px'}},
            //{label: 'Longitude: ', key: 'longitude', hidden: false, type: 'text', value: '', length: 128, styles: {'width': '350px'}},
            //{label: 'Sortierungs Priorität', key: 'priority', hidden: false, type: 'slider', value: 1, slider: {value: 1, min: 1, max: 100}},
            {flexDivider: true, styles: {'margin-bottom': '23px'}},
        ];
        this.$helpers.OpenPopup({
            elRelative: event.currentTarget,
            type: 'datafill',
            pointerDirection: 0,
            componentState: {
                entries: dataEntries,
                selectCallback: function (newCostCenter) {
                    view.createCostCenter(newCostCenter);
                },
                errorCheck: {
                  'name': (entries) => {
                    if (!entries.hasOwnProperty('name') || entries.name === '') {
                      return {
                        key: 'name',
                        label: view.$t('settings.groups.name'),
                        type: 'error',
                          text: view.$t('settings.centers.mustBeProvided')
                      }
                    } else {
                      return null;
                    }
                  }
                }
            },
            header: view.$t('settings.centers.newCostCenter'),
            remainAfterSelect: false,
            expanded: true,
        });
    },
    openEditCostCenter(costCenter){
        let view = this;

        let dataEntries = [];
        if(!costCenter.isDefault){
          dataEntries = [
              {label: 'id: ', key: 'id', hidden: true, type: 'text', value: costCenter.id, length: 128, styles: {'width': '350px'}},
              {label: view.$t('settings.groups.number') + ': ', key: 'name', hidden: false, type: 'text', value: costCenter.name, length: 128, styles: {'width': '350px'}},
              {label: view.$t('settings.centers.abbr') + ': ', key: 'shortName', hidden: false, type: 'text', value: costCenter.shortName, length: 8, styles: {'width': '350px'}},
              {label: view.$t('settings.groups.number') + ': ', key: 'costCenterNumber', hidden: false, type: 'text', value: costCenter.costCenterNumber, length: 128, styles: {'width': '350px'}},
              {label: view.$t('settings.centers.desc') + ': ', key: 'description', hidden: false, type: 'text', value: costCenter.description, length: 128, styles: {'width': '350px'}},
              {label: view.$t('settings.centers.location') + ': ', key: 'storeId', hidden: true, type: 'text', value: costCenter.storeId, length: 128, styles: {'width': '350px'}},
              {flexDivider: true, styles: {'margin-bottom': '23px'}},
          ];
        }else{
          dataEntries = [
              {label: 'id: ', key: 'id', hidden: true, type: 'text', value: costCenter.id, length: 128, styles: {'width': '350px'}},
              {label: view.$t('settings.groups.name') + ': ', key: 'name', hidden: true, type: 'text', value: costCenter.name, length: 128, styles: {'width': '350px'}},
              {label: view.$t('settings.centers.abbr') + ': ', key: 'shortName', hidden: false, type: 'text', value: costCenter.shortName, length: 8, styles: {'width': '350px'}},
              {label: view.$t('settings.groups.number') + ': ', key: 'costCenterNumber', hidden: false, type: 'text', value: costCenter.costCenterNumber, length: 128, styles: {'width': '350px'}},
              {label: view.$t('settings.centers.desc') + ': ', key: 'description', hidden: true, type: 'text', value: costCenter.description, length: 128, styles: {'width': '350px'}},
              {flexDivider: true, styles: {'margin-bottom': '23px'}},
          ];
        }

        let popupHeader = costCenter.isDefault
            ? view.$t('settings.centers.editSystemCostCenter')
            : view.$t('settings.centers.editCostCenter');

        this.$helpers.OpenPopup({
            elRelative: null,
            type: 'datafill',
            pointerDirection: 0,
            componentState: {
                entries: dataEntries,
                selectCallback: function (eCostCenter) {
                    view.editCostCenter(eCostCenter);
                },
            },
            header: popupHeader,
            remainAfterSelect: false,
            centered: true,
            expanded: true,
        });
    },
    openDeleteCostCenter(costCenter){
        let view = this;

        let dataEntries = [
            {label: 'id: ', key: 'id', hidden: true, type: 'text', value: costCenter.id, length: 128, styles: {'width': '350px'}},
            {label: '', key: 'number', hidden: false, type: 'output', value: view.$t('settings.centers.deleteConfirmMessage')},
            {label: view.$t('settings.groups.name') + ': ', key: 'name', hidden: false, type: 'output', value: costCenter.name, length: 128, styles: {'width': '350px'}},
            {flexDivider: true, styles: {'margin-bottom': '23px'}},
        ];
        this.$helpers.OpenPopup({
            elRelative: null,
            type: 'datafill',
            pointerDirection: 0,
            componentState: {
              positiveButtonLabel: view.$t('settings.notes.delete'),
                entries: dataEntries,
                selectCallback: function (dCostCenter) {
                    view.deleteCostCenter(dCostCenter);
                }
            },
            header: view.$t('settings.centers.deleteCostCenter'),
            remainAfterSelect: false,
            centered: true,
            expanded: true,
        });
    },



    createCostCenter(newCostCenter){
        let view = this;
        let url = '/api/costcenters';
        url = this.$helpers.appendParam("companyId", this.$store.state.companyId, url, '/api/costcenters');
        let payload = {
          companyId: this.$store.state.companyId,
          costCenterNumber: newCostCenter.costCenterNumber,
          name: newCostCenter.name,
          shortName: newCostCenter.shortName,
          description: newCostCenter.description
        }
        this.axios({
            method: 'post',
            headers: {
                'AUTHORIZATION': "Bearer "+view.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            view.$helpers.success(
                view.$t('settings.centers.costCenterCreated'),
                view.$t('settings.centers.costCenterCreated')
            );
            view.refresh(true);
        }).catch(function (error) {
            console.log(error)
        })
    },
    editCostCenter(eCostCenter){
        let view = this;
        let url = '/api/costcenters/'+eCostCenter.id;
        url = this.$helpers.appendParam("companyId", this.$store.state.companyId, url, '/api/costcenters/'+eCostCenter.id);
        let payload = {
          companyId: this.$store.state.companyId,
          costCenterNumber: eCostCenter.costCenterNumber,
          name: eCostCenter.name,
          shortName: eCostCenter.shortName,
          description: eCostCenter.description,
          storeId: typeof eCostCenter.storeId !== 'undefined' ? eCostCenter.storeId : null,
        }
        this.axios({
            method: 'put',
            headers: {
                'AUTHORIZATION': "Bearer "+view.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            view.$helpers.success(
                view.$t('settings.centers.costCenterUpdated'),
                view.$t('settings.centers.costCenterUpdated')
            );
            view.refresh(true);
        }).catch(function (error) {
            console.log(error)
        })
    },
    deleteCostCenter(dCostCenter){
        let view = this;
        console.log(dCostCenter);
        let url = '/api/costcenters/'+dCostCenter.id;
        url = this.$helpers.appendParam("companyId", this.$store.state.companyId, url, '/api/costcenters/'+dCostCenter.id);
        let payload = {
          companyId: this.$store.state.companyId,
        }
        this.axios({
            method: 'delete',
            headers: {
                'AUTHORIZATION': "Bearer "+view.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            view.$helpers.success(
                view.$t('settings.centers.costCenterDeleted'),
                view.$t('settings.centers.costCenterDeleted')
            );
            view.refresh(true);
        }).catch(function (error) {
            console.log(error)
        })
    },



  },
}
</script>

<!-- Add "scoped" attriemployeete to limit CSS to this component only -->
<style scoped>


.name-filter .fa-search {
    color: var(--contrast-4);
    position: absolute;
    top: 5px;
    left: 5px;
}

.half-width {
  width: 50%;
}

.fix-button-width {
  width: 150px;
}

.filter-input {
  margin-left: -45px;
  padding-left: 40px;
  width: calc(100% - 25px);
}

.list {
  width: calc(100% - 78px);
  margin: auto;
  height: 265px;
  box-shadow: inset 0 0 0 1px var(--contrast-3);
  overflow: hidden;
  position: absolute;
  border-radius: 5px;
}
.list .scroll-content {
  padding: 5px;
  overflow-y: auto;
  height: 265px;
}

.list-entry {
  height: 35px;
  margin-bottom: 2px;
  border-radius: 100px;
  cursor: pointer;
}


.list-entry:hover {
  background: var(--sub-menu);
  cursor: pointer;
}
.list-entry.selected {
  background: #e51550;
  cursor: pointer;
}
.list-entry.selected > .label,
.list-entry:hover > .label{
  color: var(--bg);
  cursor: pointer;
}
.list-entry.selected > .label > .label-small,
.list-entry.hover > .label > .label-small {
  color: var(--bg) !important;
  cursor: pointer;
}


.list-entry > .label {
  float: left;
  font-size: 14px;
  font-family: DistrictProBook;
  color: var(--contrast-4);
  padding-top: 6px;
  cursor: pointer;
}
.list-entry > .label > .label-small {
  cursor: pointer;
  color:var(--contrast-5);
}


.picture {
  float: left;
  border-radius: 100px;
  background: var(--contrast-1);
  margin-top: 5px;
  margin-left: 5px;
  margin-right: 10px;
  height: 25px;
  width: 25px;
}
.position-right{
  float: right;
  margin: 0;
  margin-right: -5px;
}
.pictureImg {
  border-radius: 100px;
  height: 25px;
  width: 25px;
}





/* width */
::-webkit-scrollbar {
  width: 10px;
  border-radius: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: var(--contrast-1);
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: var(--contrast-3);
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #aaaaaa;
}
.has-header > .has-header > .scrollbar-container{
    height: calc(100% - var(--header-height) - var(--tab-menu-height)) !important;
    overflow-x: hidden;
    top: var(--header-height);
    padding: 0px 14px;
}
</style>
